var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPorMultibanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5998 25.1996C21.5998 24.5369 22.1371 23.9996 22.7998 23.9996H27.5998C28.2625 23.9996 28.7998 24.5369 28.7998 25.1996C28.7998 25.8624 28.2625 26.3996 27.5998 26.3996H22.7998C22.1371 26.3996 21.5998 25.8624 21.5998 25.1996Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5998 29.9996C21.5998 29.3369 22.1371 28.7996 22.7998 28.7996H29.9998C30.6625 28.7996 31.1998 29.3369 31.1998 29.9996C31.1998 30.6624 30.6625 31.1996 29.9998 31.1996H22.7998C22.1371 31.1996 21.5998 30.6624 21.5998 29.9996Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7998 15.5996C4.7998 12.2855 7.48778 9.59961 10.8011 9.59961H37.1985C40.5118 9.59961 43.1998 12.2855 43.1998 15.5996V17.3996C43.1998 18.7251 42.1253 19.7996 40.7998 19.7996H10.7998C10.1371 19.7996 9.5998 19.2624 9.5998 18.5996C9.5998 17.9369 10.1371 17.3996 10.7998 17.3996H40.7998V15.5996C40.7998 13.6118 39.1872 11.9996 37.1985 11.9996H10.8011C8.81244 11.9996 7.1998 13.6118 7.1998 15.5996V32.3996C7.1998 34.3878 8.81158 35.9996 10.7998 35.9996H37.1998C39.188 35.9996 40.7998 34.3878 40.7998 32.3996V23.3996C40.7998 22.7369 41.3371 22.1996 41.9998 22.1996C42.6625 22.1996 43.1998 22.7369 43.1998 23.3996V32.3996C43.1998 35.7133 40.5135 38.3996 37.1998 38.3996H10.7998C7.4861 38.3996 4.7998 35.7133 4.7998 32.3996V15.5996Z",
    fill: "#15D4B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3998 26.9996C15.0625 26.9996 15.5998 26.4624 15.5998 25.7996C15.5998 25.1369 15.0625 24.5996 14.3998 24.5996C13.7371 24.5996 13.1998 25.1369 13.1998 25.7996C13.1998 26.4624 13.7371 26.9996 14.3998 26.9996ZM14.3998 29.3996C16.388 29.3996 17.9998 27.7878 17.9998 25.7996C17.9998 23.8114 16.388 22.1996 14.3998 22.1996C12.4116 22.1996 10.7998 23.8114 10.7998 25.7996C10.7998 27.7878 12.4116 29.3996 14.3998 29.3996Z",
    fill: "#15D4B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3997 30.5996C15.5765 30.5996 16.5885 31.4556 16.8228 32.6336C16.952 33.2837 17.5838 33.7058 18.2338 33.5766C18.8838 33.4473 19.306 32.8156 19.1767 32.1656C18.7302 29.9202 16.7774 28.1996 14.3997 28.1996C12.0221 28.1996 10.0693 29.9202 9.62279 32.1656C9.49353 32.8156 9.91569 33.4473 10.5657 33.5766C11.2157 33.7058 11.8474 33.2837 11.9767 32.6336C12.2109 31.4556 13.223 30.5996 14.3997 30.5996Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPorMultibanco);
export default __webpack_public_path__ + "static/media/iconPorMultibanco.732888d850347fd69f43302047a77297.svg";
export { ForwardRef as ReactComponent };